import PaymentCheckout from "./PaymentCheckout";

export default PaymentCheckout;
